import React, { useEffect, useState } from "react";
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const PromoPopup: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Kiểm tra trạng thái trong sessionStorage
    const promoClosed = sessionStorage.getItem("promoClosed");
    if (!promoClosed) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    sessionStorage.setItem("promoClosed", "true");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      PaperProps={{
        className: "relative bg-transparent shadow-none",
      }}
    >
      <div className="relative rounded-2xl overflow-hidden">
        {/* Nút Close */}
        <IconButton
          onClick={handleClose}
          className="float-end absolute top-2 right-2 z-10 bg-black/50 hover:bg-black/70 text-white"
        >
          <CloseIcon />
        </IconButton>

        {/* Hình quảng cáo */}
        <img
          src="/images/promo-thudoi.png" // Đường dẫn hình khuyến mãi
          alt="Chương trình khuyến mãi"
          className="w-full h-auto rounded-2xl"
        />

        {/* (Tùy chọn) Nút hành động */}
        {/* <div className="absolute bottom-4 left-0 right-0 flex justify-center">
          <button
            onClick={() => (window.location.href = "/khuyen-mai")}
            className="bg-red-500 hover:bg-red-600 text-white font-semibold px-6 py-2 rounded-full shadow-lg"
          >
            Xem chi tiết
          </button>
        </div> */}
      </div>
    </Dialog>
  );
};

export default PromoPopup;
